(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["botanika-story"] && !Shopify.designMode) return;
  try {
    (()=>{
 const init=(scope)=>scope.querySelectorAll('[data-botanika-story]').forEach(root=>{
  if(root.dataset.bkInit==='1')return;
  root.dataset.bkInit='1';
  const fit=()=>root.style.setProperty('--bk-viewport',document.documentElement.clientWidth+'px');
  fit();
  if('ResizeObserver' in window){
    const observer=new ResizeObserver(fit);
    observer.observe(document.documentElement);
    document.addEventListener('shopify:section:unload',event=>{
      if(event.target.contains(root))observer.disconnect();
    },{once:true});
  }else{
    window.addEventListener('resize',fit,{passive:true});
  }
 });
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eternal-story"] && !Shopify.designMode) return;
  try {
    (()=>{
 const init=(scope)=>scope.querySelectorAll('[data-eternal-story]').forEach(root=>{
  if(root.dataset.egInit==='1')return;
  root.dataset.egInit='1';
  const fit=()=>root.style.setProperty('--eg-viewport',document.documentElement.clientWidth+'px');
  fit();
  if('ResizeObserver' in window){
    const observer=new ResizeObserver(fit);
    observer.observe(document.documentElement);
    document.addEventListener('shopify:section:unload',event=>{
      if(event.target.contains(root))observer.disconnect();
    },{once:true});
  }else{
    window.addEventListener('resize',fit,{passive:true});
  }
 });
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hydra-story"] && !Shopify.designMode) return;
  try {
    (()=>{
 const init=(scope)=>scope.querySelectorAll('[data-hydra-story]').forEach(root=>{
  if(root.dataset.hsInit==='1')return;
  root.dataset.hsInit='1';
  const fit=()=>root.style.setProperty('--hs-viewport',document.documentElement.clientWidth+'px');
  fit();
  if('ResizeObserver' in window){
    const observer=new ResizeObserver(fit);
    observer.observe(document.documentElement);
    document.addEventListener('shopify:section:unload',event=>{
      if(event.target.contains(root))observer.disconnect();
    },{once:true});
  }else{
    window.addEventListener('resize',fit,{passive:true});
  }
 });
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sultanea-back-to-top"] && !Shopify.designMode) return;
  try {
    const backToTop = document.getElementById('SultaneaBackToTop');
  if (backToTop) {
    let scheduled = false;
    const update = () => {
      backToTop.hidden = window.scrollY < 400;
      scheduled = false;
    };
    window.addEventListener('scroll', () => {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('pageshow', update);
    backToTop.addEventListener('click', () => {
      const header = document.getElementById('header-group');
      if (header) {
        const previousTabindex = header.getAttribute('tabindex');
        header.setAttribute('tabindex', '-1');
        header.focus({ preventScroll: true });
        header.addEventListener('blur', () => {
          if (previousTabindex === null) header.removeAttribute('tabindex');
          else header.setAttribute('tabindex', previousTabindex);
        }, { once: true });
      }
      window.scrollTo({ top: 0, left: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    update();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sultanea-deals"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-su-deals-prev],[data-su-deals-next]');
  if(!button)return;
  const section=button.closest('.su-deals');
  const track=section&&section.querySelector('[data-su-deals-rail]');
  const card=track&&track.querySelector('.su-deals__card');
  if(!track||!card)return;
  const gap=parseFloat(getComputedStyle(track).columnGap)||0;
  const direction=button.hasAttribute('data-su-deals-prev')?-1:1;
  track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});

document.addEventListener('click',function(event){
  const toggle=event.target.closest('[data-su-deals-toggle]');
  if(!toggle)return;
  const section=toggle.closest('.su-deals');
  if(!section)return;
  const expanded=section.classList.toggle('su-deals--expanded');
  toggle.setAttribute('aria-expanded',String(expanded));
  const label=toggle.querySelector('[data-su-deals-toggle-label]');
  if(label)label.textContent=expanded?'MOSTRAR MENOS':'VER TODAS LAS OFERTAS';
  section.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
});
  } catch(e) { console.error(e); }
})();

})();
